import { SAVE_PERSON_DATA } from "../actions/person-data.type";
import { personDataState } from "../interfaces/state-data.interface";
import { personDataAction } from "../types/actions-reducer.type";

const personDataReducer = (state:personDataState, action:personDataAction) => {

    const { type, payload } = action;

    switch(type) {
        case SAVE_PERSON_DATA:
            return { ...state, ...payload }
        default:
            return state;
    }
}

export default personDataReducer;